import { useCallback } from 'react';
import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import {
  useCorporateBondScreenerDictionariesContext,
} from '../CorporateBondScreenerDictionariesContext';
import { buildViewFilterPayload } from '../buildViewFilterPayload';
import { DEFAULT_FILTERS } from '../buildCorporateBondScreenerRequest';

const useCorporateViewFiltersMapper = (): (viewFilters: Partial<TFilterPayload> | null) => TFilterPayload => {
  const { industries } = useCorporateBondScreenerDictionariesContext();

  return useCallback(
    (viewFilters) => buildViewFilterPayload(viewFilters, DEFAULT_FILTERS, industries.getAll()),
    [industries],
  );
};

export default useCorporateViewFiltersMapper;
